import useApi from '../Hooks/useApi'
import Loader from '../Components/Loader'

const Dashboard = (props) => {
    const {data} = useApi( {url: '/Registration/DashboardSummary', method: 'get' });

  return (
    <>
    {!data ? (<Loader />) : (

    
                            <div className="content">
                                <div className="header">
                                    <label className="title"> Dashboard </label>
                                </div>
                                <div className="body">
                                    <div className="animate-bottom">

                                    <div className="table-responsive"> 
                                                            <table className='table table-striped table-hover table-bordered caption-top'>
                                                                <thead className="table-light">
                                                                    <tr>
                                                                        <th>Category</th>
                                                                        <th className=''>Sanctioned Seats</th>
                                                                        <th>Applied Seats</th>
                                                                    </tr>
                                                                </thead>
                                                                
                                                                <tbody>


                                                                {data.map((row) => {
                                                                    return (
                                                                        <>
                                                                            <tr key={row.categoryID}>
                                                                                <td>{row.categoryName}</td>
                                                                                <td>{row.affiliatedSeats}</td>
                                                                                <td>{row.registeredSeats}</td>
                                                                            </tr>
                                                                        </>
                                                                    )
                                                                  })
                                                                }
                                                                </tbody>
                                                        </table>
                                                        </div>


                                    </div>


                                    
                                </div>
                            </div>
        )
    }
    </>
  );

};

export default Dashboard;